const autoNgTemplateLoaderTemplate1 = require('./internal-auth.html');

export const internalAuth = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    onSaveSettings: '<',
    saveButtonState: '<',
  },
};
